import React from 'react'
import Heroright from './Heroright'
import Herosection from './Herosection'
import'./Home.css'
import Mywork from './Mywork'
import Sidebar from './Sidebar'

function Home() {
  return (
    <div className='home'>
        <div className='home__body'>           
           <Sidebar/>
           <Herosection/>  
           <Heroright/>  
           
                             
         </div>       
    </div>
  )
}

export default Home